import { createContext, useContext, useState } from "react";

const objectEditdataContext=createContext()

export const ObjectEditProvider=({children})=>{
    const [objectEditData,setObjectEditData]=useState({
        objectId:"",
        objectName:"",
        objectImage:"",
        category:"",
        subCategory:""
    })

    return(
        <objectEditdataContext.Provider value={{objectEditData,setObjectEditData}}>
            {children}
        </objectEditdataContext.Provider>
    )
}

export const ObjectEditsaving=()=>useContext(objectEditdataContext)